import backendService from '../app/backendService';
import gamMessageRequestService from '../gam/gamMessageRequestService';
import uamMessageRequestService from '../uam/uamMessageRequestService';

const client = () => {
    if (backendService.isGamBackend()) {
        return gamMessageRequestService;
    } else {
        return uamMessageRequestService;
    }
};

export default client;
